import { api } from './api';
import { getLocalAppSession } from 'utils/storageHelpers';

const customerHeader = () => ({
  'Active-Customer': getLocalAppSession()?.activeCustomer,
});

/**
 * Record that the signed-in person has now looked at a generated video clip. SYM-6076.
 *
 * Idempotent on the server, so this can be called on every selection without the caller keeping
 * track of whether it has called before.
 *
 * Deliberately swallows its own failure. This is a badge: losing the call means the dot comes
 * back on the next load, which is a far better outcome than an error in front of somebody who
 * only clicked on their own advert.
 */
export const markAdVariantClipSeen = async (
  variantId: number
): Promise<void> => {
  try {
    await api.post(`/v4/ad-variants/${variantId}/clip-seen`, undefined, {
      headers: customerHeader(),
    });
  } catch {
    // See above: a badge is not worth an error message.
  }
};
